// COMPONENTS
import InfoBar from "../../infoBar.component";
import CountInfoTag from "../../infoTags/count.infoTag.infoBar.component";
import SelectedInfoTag from "../../infoTags/selected/seletcted.infoTag.compnent";

const PermissionInfoBar = ({
  metaData = { totalCount: 0 },
  selectedTagProps = { handleClear: () => {}, label: "" },
}) => {
  return (
    <InfoBar>
      <CountInfoTag>Count: {metaData?.totalCount || 0}</CountInfoTag>
      <SelectedInfoTag
        handleClear={selectedTagProps?.handleClear}
        label={selectedTagProps?.label || ""}
      />
    </InfoBar>
  );
};

export default PermissionInfoBar;
